import { config } from "@/config";
import { authenticationService } from "./authentication.service";

let { authHeader, handleResponse } = authenticationService;

export const batchService = {
  upload,
  all,
  get,
  tag,
};

async function all(range) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  let response = await fetch(
    `${config.api.base}/stockbatchs/list/${range}`,
    requestOptions
  );
  return await handleResponse(response);
}

async function upload(files) {
  let formData = new FormData();

  for (var i = 0; i < files.length; i++) {
    let file = files[i];
    formData.append("files", file);
  }

  const requestOptions = {
    method: "POST",
    body: formData,
    headers: authHeader(),
  };

  let response = await fetch(
    `${config.api.base}/stockbatchs/xlsx`,
    requestOptions
  );
  return await handleResponse(response);
}

async function get(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  let response = await fetch(
    `${config.api.base}/stockbatchs/${id}`,
    requestOptions
  );
  return await handleResponse(response);
}

async function tag(tagType, ids) {
  let contentType = { "Content-Type": "application/json" };
  const requestOptions = {
    method: "POST",
    headers: { ...contentType, ...authHeader() },
    body: JSON.stringify(ids),
  };
  let response = await fetch(
    `${config.api.base}/stockbatchs/tag/${tagType}`,
    requestOptions
  );
  return await handleResponse(response);
}
